"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetMembers = exports.fetchMembersByTeamId = void 0;

var _utils = require("@alycecom/utils");

var _reduxAct = require("redux-act");

var prefix = 'MODULES/TEAMS/MEMBERS';
var fetchMembersByTeamId = (0, _utils.createAsyncAction)("".concat(prefix, "/FETCH_BY_TEAM_ID"));
exports.fetchMembersByTeamId = fetchMembersByTeamId;
var resetMembers = (0, _reduxAct.createAction)("".concat(prefix, "/RESET"));
exports.resetMembers = resetMembers;